import axios from 'axios';
//import * as RootNavigation from '../utils/RootNavigation'; // This will depend on your routing setup
import Auth from '../../src/utils/Auth';

const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_URL;
const REACT_APP_API_VERSION = process.env.REACT_APP_API_VERSION;
const REACT_APP_PAGE_BUILDER_API_URL = process.env.REACT_APP_PAGE_BUILDER_API_URL;
//const baseDomain = API_BASE;
const apiVersion = REACT_APP_API_VERSION ? REACT_APP_API_VERSION : '';
const baseURL = `${REACT_APP_API_BASE_URL}${apiVersion}`;
const pageBuilderApiBaseURL = `${REACT_APP_PAGE_BUILDER_API_URL}`;

console.log("API Base URL:", pageBuilderApiBaseURL); 

const Service = axios.create({
    baseURL: pageBuilderApiBaseURL,
    //timeout: 1000000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
});

// Request interceptor to add the authorization token
Service.interceptors.request.use(async (config) => {
    const authToken = await Auth.getAuthToken();
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    // Add current URL to headers
    config.headers['X-Current-Path'] = window.location.href;
    return config;
});

// // Response interceptor for handling responses and errors
// Service.interceptors.response.use(
//     (response) => {
//         if (response.status === 200 || response.status === 201) {
//             return response;
//         } else {
//             return Promise.reject(response);
//         }
//     },
//     async (error) => {
//         if (error?.response?.status === 401) {
//             await Auth.clearAuthToken();
//             RootNavigation.resetRoot(0, 'SignIn'); // Adjust based on your routing
//             return Promise.reject(error.response);
//         } else {
//             return Promise.reject(error.response);
//         }
//     },
// );

// const AdminService = axios.create({
//     baseURL: getBaseURL('admin'),
//     timeout: 10000,
//     headers: {
//         'Content-Type': 'application/json;charset=UTF-8',
//     },
// });

//export { Service, AdminService };

export default Service;
